import Collection from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

const initialCodeState = {
  id: null,
  code: '',
  release: false
}

const initialJsonState = {
  id: null,
  json: ''
}

const initialTextState = {
  id: null,
  text: '',
}

export default {
  namespaced: true,
  state: {
    collections: [],
    filteredCollection: [],
    current: new Collection(),
    currentCode: initialCodeState,
    currentJson: initialJsonState,
    currentText: initialTextState,
  },
  getters: {
    getCollection: state => state.collections,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.collections.find(collection => collection.id === id),
    getCurrent: state => state.current,
    getCurrentCode: state => state.currentCode,
    getCurrentJson: state => state.currentJson,
    getCurrentText: state => state.currentText
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      const id = payload.id
      delete payload.id
      return this.dispatch('get', {
        path: 'v1/collectionItemTemplates/theme/' + id,
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((collection) => {
            commit('addCollectionToCollection', { collectionData: collection })
            return getters.getById(collection.id)
          })

          commit('addCollectionToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    getCode ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/collectionItemTemplates/' + id + '/code'
      }).then((res) => {
        commit('updateCurrentCode', res && res.body)
      })
    },
    getJson ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/collectionItemTemplates/' + id + '/json'
      }).then((res) => {
        commit('updateCurrentJson', res && res.body)
      })
    },
    getText ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/collectionItemTemplates/' + id + '/text'
      }).then((res) => {
        commit('updateCurrentText', res && res.body)
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/collectionItemTemplates',
        data: model.getJSON()
      }).then((res) => {

        commit('addCollectionToCollection', { collectionData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/collectionItemTemplates/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addCollectionToCollection', { collectionData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/collectionItemTemplates/' + id
      }).then((res) => {

        commit('removeCollectionFromCollection', id)

        return res
      })
    },
    updateCode (store, payload) {
      return this.dispatch('put', {
        path: 'v1/collectionItemTemplates/' + payload.id + '/code',
        data: payload
      })
    },
    updateJson (store, payload) {
      return this.dispatch('put', {
        path: 'v1/collectionItemTemplates/' + payload.id + '/json',
        data: payload
      })
    },
    updateText (store, payload) {
      return this.dispatch('put', {
        path: 'v1/collectionItemTemplates/' + payload.id + '/text',
        data: payload
      })
    },
  },
  mutations: {
    addCollectionToCollection(state, { collectionData, opts }) {
      addToCollection(this, state.collections, collectionData, Collection, opts)
    },
    addCollectionToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeCollectionFromCollection(state, collectionId) {
      const index = state.collections.findIndex(el => el.id === collectionId)

      if (index === -1) {
        console.warn(`Could not find/delete collection ${collectionId}`)
        return
      }

      state.collections.splice(index, 1)
    },
    clearCollection(state) {
      state.collections = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent (state, collection) {
      state.current = collection
    },
    updateCurrentCode (state, code) {
      state.currentCode = code
    },
    updateCurrentJson (state, json) {
      state.currentJson = json
    },
    updateCurrentText (state, text) {
      state.currentText = text
    },
    resetCurrent (state) {
      state.current = new Collection()
    },
    resetCurrentCode (state) {
      state.currentCode = {...initialCodeState}
    },
    resetCurrentText (state) {
      state.currentText = {...initialTextState}
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/collection/store.js